import { render, staticRenderFns } from "./ChatEmoji.vue?vue&type=template&id=5f09c9c5&scoped=true"
import script from "./ChatEmoji.vue?vue&type=script&lang=js"
export * from "./ChatEmoji.vue?vue&type=script&lang=js"
import style0 from "./ChatEmoji.vue?vue&type=style&index=0&id=5f09c9c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f09c9c5",
  null
  
)

export default component.exports